<template>
  <b-carousel id="carousel" v-model="slide" :interval="0" controls indicators background="#8a8c8d"
    @sliding-start="onSlideStart" @sliding-end="onSlideEnd" :no-animation="false">
    <b-carousel-slide v-for="item in list" :key="item.id">
      <template v-slot:img>
        <b-container class="" fluid>
          <b-row>
            <b-col col sm="auto" class="pt-4"> </b-col>
          </b-row>

          <b-row class="image-container-row">
            <!-- PREV Padding -->
            <b-col class="col-half"></b-col>

            <template v-if="item.type == '3LeftRight'">
              <b-col sm="auto" class="mx-auto px-0 mx-0 c-center">
                <div class="mb-4">
                  <img class="img-height-max" :src="item.leftTopImage" :height="item.leftTopImageHeight" />
                </div>
                <div class="d-flex justify-content-between">
                  <img class="img-height-max" :src="item.leftBottomLeftImage" :height="item.leftBottomLeftImageHeight" />

                  <img class="img-height-max" :src="item.leftBottomRightImage"
                    :height="item.leftBottomRightImageHeight" />
                </div>
              </b-col>
              <b-col sm="auto" class="mx-auto px-0 mx-0 c-center">
                <img class="img-height-max" :src="item.rightImage" :height="item.rightImageHeight" />
              </b-col>
            </template>

            <template v-if="item.type == 'LeftRight'">
              <b-col class="m-auto c-center text-center">
                <img class="img-height-max" :src="item.leftImage" :height="item.leftImageHeight" />
              </b-col>
              <b-col class="m-auto c-center text-center">
                <img class="img-height-max" :src="item.rightImage" :height="item.rightImageHeight" />
              </b-col>
            </template>

            <template v-if="item.type == 'LeftRightText'">
              <b-col class="m-auto c-center text-center">
                <img class="img-height-max" :src="item.leftImage" :height="item.leftImageHeight" />
              </b-col>
              <b-col class="align-bottom text-bottom text-white">
                <p>
                  Malerierne er udført på rejser i perioden 2002-2022.
                </p>
                <p>
                  De er alle tegnet og malet på stedet direkte over for motivet. De er udført i acryl og de har
                  formatet 21x30cm.
                </p>
                <p>
                  Billederne kan erhverves efter aftale.
                </p>
                <p class="py-0 px-0 mx-0 my-0">
                  NV
                </p>
              </b-col>
            </template>

            <template v-if="item.type == 'LeftRightText2'">
              <b-col class="m-auto c-center text-center">
                <img class="img-height-max" :src="item.leftImage" :height="item.leftImageHeight" />
              </b-col>
              <b-col class="align-bottom text-bottom text-white">
                <p>
                  Tegningerne er et udvalg fra mine skitsebøger fra perioden 1986-2023. Alle bøgerne har formatet 14,5 X
                  21 cm som svarer til A5. Tegningerne er udført med pen og sort blæk eller med sort tusch. Alle er udført
                  direkte over for motivet.
                </p>
                <p class="py-0 px-0 mx-0 my-0">
                  NV
                </p>
              </b-col>
            </template>


            <template v-if="item.type == 'Left2Middle2Right'">
              <b-col class="c-center text-center">
                <img class="img-height-max" :src="item.leftImage" :height="item.leftImageHeight" />
              </b-col>
              <b-col class="">
                <div class=" text-center mb-4">
                  <img class="img-height-max" :src="item.middleTopImage" :height="item.middleTopImageHeight" />
                </div>
                <div class="text-center">
                  <img class="img-height-max" :src="item.middleBottomImage" :height="item.middleBottomImageHeight" />
                </div>
              </b-col>
              <b-col class="">
                <div class=" text-center mb-4">
                  <img class="img-height-max" :src="item.rightTopImage" :height="item.rightTopImageHeight" />
                </div>
                <div class="text-center">
                  <img class="img-height-max" :src="item.rightBottomImage" :height="item.rightBottomImageHeight" />
                </div>
              </b-col>
            </template>

            <template v-if="item.type == 'LeftMiddleRight'">
              <b-col class="mx-1 px-0 c-center text-center">
                <img class="img-height-max" :src="item.leftImage" :height="item.leftImageHeight" />
              </b-col>
              <b-col class="mx-1 px-0 c-center text-center">
                <img class="img-height-max" :src="item.middleImage" :height="item.middleImageHeight" />
              </b-col>
              <b-col class="mx-1 px-0 c-center text-center">
                <img class="img-height-max" :src="item.rightImage" :height="item.rightImageHeight" />
              </b-col>
            </template>

            <template v-if="item.type == 'LeftMiddle2Right'">
              <b-col sm="auto" class="text-center c-center">
                <img class="img-height-max" :src="item.leftImage" :height="item.leftImageHeight" />
              </b-col>
              <b-col class="c-center text-center">
                <img class="img-height-max" :src="item.middleImage" :height="item.middleImageHeight" />
              </b-col>
              <b-col class="c-center text-center">
                <div class="text-center mb-4">
                  <img class="img-height-max" :src="item.rightTopImage" :height="item.rightTopImageHeight" />
                </div>
                <div class="text-center">
                  <img class="img-height-max" :src="item.rightBottomImage" :height="item.rightBottomImageHeight" />
                </div>
              </b-col>
            </template>

            <template v-if="item.type == '2LeftRight'">
              <b-col class="mx-auto c-center">
                <div class="text-center mb-4">
                  <img class="img-height-max" :src="item.leftTopImage" :height="item.leftTopImageHeight" />
                </div>
                <div class="text-center">
                  <img class="img-height-max" :src="item.leftBottomImage" :height="item.leftBottomImageHeight" />
                </div>
              </b-col>
              <b-col class="mx-auto c-center text-center">
                <img class="img-height-max" :src="item.rightImage" :height="item.rightImageHeight" />
              </b-col>
            </template>

            <template v-if="item.type == 'Left2Right'">
              <b-col sm="auto" class="mx-auto c-center px-0">
                <img class="img-height-max" :src="item.leftImage" :height="item.leftImageHeight" />
              </b-col>
              <b-col class="mx-auto c-center px-0">
                <div class="text-center mb-4">
                  <img class="img-height-max" :src="item.rightTopImage" :height="item.rightTopImageHeight" />
                </div>
                <div class="text-center">
                  <img class="img-height-max" :src="item.rightBottomImage" :height="item.rightBottomImageHeight" />
                </div>
              </b-col>
            </template>

            <template v-if="item.type == '2TopBottom'">
              <b-col cols="11" class="mx-auto c-center">
                <b-row>
                  <b-col class="mx-auto c-center px-0">
                    <div class="text-center mb-4">
                      <img class="img-height-max mx-4" :src="item.topLeftImage" :height="item.topLeftImageHeight" />
                      <img class="img-height-max" :src="item.topRightImage" :height="item.topRightImageHeight" />
                    </div>
                  </b-col>
                  <b-col class="mx-auto c-center text-center px-0">
                    <img class="img-height-max" :src="item.bottomImage" :height="item.bottomImageHeight" />
                  </b-col>
                </b-row>
              </b-col>
            </template>

            <template v-if="item.type == 'Center'">
              <b-col cols="11" class="mx-auto c-center">
                <b-row>
                  <b-col class="mx-auto c-center text-center px-0">
                    <img class="img-height-max" :src="item.centerImage" :height="item.centerImageHeight" />
                  </b-col>
                </b-row>
              </b-col>
            </template>

            <template v-if="item.type == 'Left2MiddleRight'">
              <b-col sm="auto" class="mx-auto px-0 c-center">
                <img class="img-height-max" :src="item.leftImage" :height="item.leftImageHeight" />
              </b-col>

              <b-col sm="auto" class="mx-auto px-0 c-center">
                <div class="text-center mb-4">
                  <img class="img-height-max" :height="item.middleTopImageHeight" :src="item.middleTopImage" />
                </div>
                <div class="text-center">
                  <img class="img-height-max" :height="item.middleBottomImageHeight" :src="item.middleBottomImage" />
                </div>
              </b-col>

              <b-col sm="auto" class="mx-auto px-0 c-center">
                <img class="img-height-max" :src="item.rightImage" :height="item.rightImageHeight" />
              </b-col>
            </template>

            <template v-if="item.type == '2LeftMiddle2Right'">
              <b-col sm="auto" class="mx-auto px-0 c-center">
                <div class="text-center mb-4">
                  <img class="img-height-max" :height="item.leftTopImageHeight" :src="item.leftTopImage" />
                </div>
                <div class="text-center">
                  <img class="img-height-max" :height="item.leftBottomImageHeight" :src="item.leftBottomImage" />
                </div>
              </b-col>

              <b-col sm="auto" class="mx-auto px-0 c-center">
                <img class="img-height-max" :src="item.middleImage" :height="item.middleImageHeight" />
              </b-col>

              <b-col sm="auto" class="mx-auto px-0 c-center">
                <div class="text-center mb-4">
                  <img class="img-height-max" :height="item.rightTopImageHeight" :src="item.rightTopImage" />
                </div>
                <div class="text-center">
                  <img class="img-height-max" :height="item.rightBottomImageHeight" :src="item.rightBottomImage" />
                </div>
              </b-col>
            </template>

            <!-- NEXT Padding -->
            <b-col class="col-half"></b-col>
          </b-row>
          <b-row>
            <b-col col sm="auto" class="pb-4"> </b-col>
          </b-row>

          <ImageDescriptionRow :leftText="item.leftText" :centerText="item.centerText" :rightText="item.rightText">
          </ImageDescriptionRow>
        </b-container>
      </template>
    </b-carousel-slide>
  </b-carousel>
</template>

<script>
import ImageDescriptionRow from "@/components/ImageDescriptionRow.vue";

export default {
  name: "ImageList",
  components: {
    ImageDescriptionRow
  },
  props: {
    list: Array
  },
  data() {
    return {
      slide: 1 - 1,
      sliding: null
    };
  },
  computed: {
    activeImage: function () {
      return this.list[this.slide];
    }
  },
  methods: {
    onSlideStart() {
      // window.console.log(slide);
      this.sliding = true;
    },
    onSlideEnd() {
      // window.console.log(slide);
      this.sliding = false;
    }
  }
};
</script>
